export enum TYPE_INSERT_KEY {
  START = "START",
  STANDARD = "STANDARD",
  VIP = "VIP",
}

export type InsertType = {
  translationId: string;
  descriptions: Array<string>;
  price: string;
  queryValue: string;
};
export const TYPE_INSERT: { [key in TYPE_INSERT_KEY]: InsertType } = {
  START: {
    translationId: "Start",
    descriptions: [
      "Odložená možnost kontaktování inzerátu.",
      "Inzerát bude zveřejněn 30 dní.",
    ],
    price: "49 Kč",
    queryValue: "offersSorting.best",
  },
  STANDARD: {
    translationId: "Standard",
    descriptions: [
      "Možnost kontaktovat ihned.",
      "Inzerát bude zveřejněn 30 dní.",
    ],
    price: "149 Kč",
    queryValue: "offersSorting.latest",
  },
  VIP: {
    translationId: "VIP",
    descriptions: [
      "Možnost kontaktovat ihned.",
      "Neomezená platnost inzerce.",
      "Výpis inzerátu mezi prvními.",
      "Zobrazení v doporučených.",
    ],
    price: "399 Kč",
    queryValue: "offersSorting.latest",
  },
};
